import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 612.000000 408.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,408.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M3808 2493 c-44 -52 -62 -81 -54 -85 18 -12 55 -9 85 7 31 16 133
139 124 149 -4 3 -25 6 -48 6 -40 0 -45 -4 -107 -77z"
          />
          <path
            d="M3008 2274 c-15 -14 -8 -61 13 -87 28 -37 77 -47 270 -57 159 -8 209
-18 209 -41 0 -5 -6 -25 -14 -44 -21 -49 -56 -56 -323 -62 -153 -4 -236 -9
-241 -17 -13 -17 -82 -144 -82 -152 0 -11 551 4 609 16 125 27 226 102 251
186 24 86 24 131 0 168 -35 49 -87 64 -285 76 -93 5 -181 13 -194 17 -14 3
-22 2 -18 -3 3 -5 -32 -7 -84 -4 l-89 5 -1 -25 c-1 -24 -2 -24 -8 3 -3 16 -9
25 -13 21z"
          />
          <path
            d="M2074 2219 c-53 -42 -90 -86 -115 -137 -29 -59 -23 -137 15 -186 32
-42 43 -45 52 -12 3 14 12 27 20 30 13 5 12 11 -3 38 -24 45 -23 142 1 188 10
19 32 52 48 73 36 45 33 46 -18 6z"
          />
          <path
            d="M3875 2089 c-26 -50 -45 -93 -42 -95 5 -5 81 131 92 165 13 43 -4 18
-50 -70z"
          />
          <path
            d="M4250 1998 c-47 -16 -86 -34 -88 -38 -2 -5 -10 -6 -18 -3 -8 3 -14 0
-14 -7 0 -20 56 -6 150 39 101 47 88 52 -30 9z"
          />
          <path d="M3580 1780 c-13 -8 -13 -10 2 -10 9 0 20 5 23 10 8 13 -5 13 -25 0z" />
          <path d="M2488 1733 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M2508 1717 c-16 -13 -16 -15 10 -27 34 -17 405 -27 382 -11 -12 8 -6
11 24 11 80 0 26 8 -129 19 -88 7 -185 14 -215 17 -38 3 -60 1 -72 -9z"
          />
          <path d="M3666 1721 c-4 -6 -3 -18 2 -27 8 -15 10 -14 16 2 8 20 -8 42 -18 25z" />
          <path
            d="M3365 1618 c-33 -11 -116 -35 -185 -54 -122 -33 -109 -38 20 -8 64
16 241 72 249 80 9 9 -27 1 -84 -18z"
          />
          <path d="M3545 1611 c-6 -11 9 -23 19 -14 9 9 7 23 -3 23 -6 0 -12 -4 -16 -9z" />
          <path
            d="M2026 1507 c-8 -35 -18 -71 -21 -80 -5 -12 6 -10 56 10 78 32 217 60
332 69 48 4 86 8 85 9 -2 2 -70 8 -153 14 -82 6 -175 18 -205 26 -30 8 -60 15
-66 15 -6 0 -19 -29 -28 -63z"
          />
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
